<template>
<div>
    <Navigation></Navigation>
    <div class="bg_color_2">
        <div class="container margin_60_35">
            <div id="login">
                
                <div class="box_form">
                    <LoginBox @logged="logged"></LoginBox>
                </div>
            </div>

        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import LoginBox from '@/components/LoginBox';
export default {
    name: 'Login',
    metaInfo: {
		title: 'Ingresar',
	},
    components: {
        Navigation,
        Footer,
        LoginBox
    },
    methods: {
		logged(){
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
#login {
    width: 400px;
    margin: 60px auto;
    color: #fff;
}

@media (max-width: 767px) {
    #login {
        /* For less than 767px */
        width: 100%;
        margin: 30px 0;
    }
}

</style>
